import { API } from './API';
import { auth } from '../auth';

const DEFAULT_OPTIONS = {
  baseUrl: 'settings',
};

export class SettingsAPI extends API {
  constructor(options = {}) {
    super({ ...DEFAULT_OPTIONS, ...options });
  }

  get() {
    if (!auth.person_id) {
      return Promise.resolve({ data: {} });
    }
    const params = [auth.person_id];
    return super.get({ params });
  }
}



// WEBPACK FOOTER //
// ./src/lib/api/SettingsAPI.js